import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['userIsCompany'])
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/form/resources/computed.js